



















import {Prop, Vue} from 'vue-property-decorator';
import Component from "vue-class-component";
import {ContentVisibility} from "@/types/WrapperConfig";

@Component
export default class Wrapper extends Vue {

  @Prop({
    type: String,
    default: '',
  })
  public title!: string;

  public isContentVisible: ContentVisibility = ContentVisibility.Hidden;

  public isContentVisibleImage = {
    'visible': require('@/assets/icon-angle-top.svg'),
    'hidden': require('@/assets/icon-angle-bot.svg'),
  };

  toggleVisibility() {
    this.isContentVisible = (this.isContentVisible === ContentVisibility.Hidden) ? ContentVisibility.Visible : ContentVisibility.Hidden;
  }

}


